import React from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import * as API from "src/api/request";

const SSO = () => {
  const { search } = useLocation();
  let params = queryString.parse(search);

  /**
   * Нэвтрэхийн ӨМНӨ нээх гэж байсан хуудас руу буцаана.
   *
   * ⚠ Урьд нь ХАМААРАЛГҮЙ `/me` рүү явдаг байв. Ажилтан талбар дээр тоног
   *   төхөөрөмжийн QR уншуулаад нэвтрэхэд юу үзэх гэж байснаа алддаг байсан.
   *
   * ⚠ ЗӨВХӨН дотоод, харьцангуй зам зөвшөөрнө. Гаднаас ирсэн бүтэн хаяг
   *   (`//evil.example`, `https://…`) бол `/me` рүү унана — эс бөгөөс
   *   нэвтрэлтийн урсгалыг өөр сайт руу чиглүүлэх нүх үүснэ.
   */
  const nextPath = () => {
    try {
      const p = sessionStorage.getItem("post_login_path");
      sessionStorage.removeItem("post_login_path");
      if (p && p.startsWith("/") && !p.startsWith("//")) return p;
    } catch (e) {
      /* хувийн горимд sessionStorage хаалттай байж болно */
    }
    return "/me";
  };

  if (params.error) window.location.replace("https://digital.erdenetmc.mn");
  else {
    API.postAuth({
      code: params.code,
    }).then((res) => {
      if (res.status === 200) {
        const go = nextPath();          // localStorage.clear()-ээс ӨМНӨ уншина
        window.localStorage.clear();
        localStorage.setItem("token", res.data.token);
        window.location.replace(go);
      }
    });
  }

  return <></>;
};

export default React.memo(SSO);
